import {
  createContext,
  ReactNode,
  useContext as useReactContext,
  useState,
} from 'react'

interface SwitchContextContextType {
  isSwitching: boolean
  setIsSwitching: (value: boolean) => void
  /** Full-screen blur overlay while leaving /admin after impersonation (same UI as context switch). */
  isImpersonationExitOverlay: boolean
  setImpersonationExitOverlay: (value: boolean) => void
}

const SwitchContextContext = createContext<
  SwitchContextContextType | undefined
>(undefined)

export const SwitchContextProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [isSwitching, setIsSwitching] = useState(false)
  const [isImpersonationExitOverlay, setImpersonationExitOverlay] =
    useState(false)

  return (
    <SwitchContextContext.Provider
      value={{
        isSwitching,
        setIsSwitching,
        isImpersonationExitOverlay,
        setImpersonationExitOverlay,
      }}
    >
      {children}
    </SwitchContextContext.Provider>
  )
}

export const useSwitchContextState = () => {
  const context = useReactContext(SwitchContextContext)
  if (context === undefined) {
    throw new Error(
      'useSwitchContextState must be used within a SwitchContextProvider'
    )
  }
  return context
}
